import { useFeatureValue } from '@growthbook/growthbook-react';
import { useMemo } from 'react';
import {
  DEFAULT_IFRAME_ALLOWLIST,
  IframeAllowlistEntry,
  normalizeIframeAllowlist,
} from '@/utils/validators/isAllowedIframeSrc';

export const IFRAME_ALLOWLIST_FLAG = 'iframe-allowlist';

export const useIframeAllowlist = (): IframeAllowlistEntry[] => {
  const raw = useFeatureValue(
    IFRAME_ALLOWLIST_FLAG,
    DEFAULT_IFRAME_ALLOWLIST,
  ) as unknown;
  return useMemo(() => normalizeIframeAllowlist(raw), [raw]);
};
